import {Divider, Grid, GridProps} from "@mantine/core";
import {PropsWithChildren, useCallback} from "react";
import {FromToDateForm, FromToDateFormProps, FromToDateFormValues} from "../../../form/FromToDateForm/FromToDateForm";

export type EntityInsightsViewProps = Omit<GridProps, 'children' | 'onSubmit'> & {
  form: Pick<FromToDateFormProps, 'defaultValues'>
  onSubmit: (fromDate: Date, toDate: Date | undefined) => void
}

export const EntityInsightsView = (props: PropsWithChildren<EntityInsightsViewProps>) => {
  const {
    form,
    onSubmit,
    children,
    ...rest
  } = props

  const onFormSubmit = useCallback((values: FromToDateFormValues) => {
    if (onSubmit) {
      onSubmit(values.fromDate!, values.toDate)
    }
  }, [onSubmit])

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <FromToDateForm
          onSubmit={onFormSubmit}
          defaultValues={form.defaultValues}
          requireFromDttm={true}/>
      </Grid.Col>
      <Grid.Col span={12}>
        <Divider />
      </Grid.Col>
      <Grid.Col span={12}>
        {children}
      </Grid.Col>
    </Grid>
  )
}
